// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import ButtonBase from '@material-ui/core/ButtonBase';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
//import Map from './Map';
//import Map from '../../map/Map';
//import SingleMap from '../../map/SingleMap';
//import SaveIcon from '@material-ui/icons/Save';
//import ImagePicker from './ImagePicker';
//import Option from '../option/View';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signTypeItem : {
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
  },

}));




export default function SignBasic(props) {
	const classes = useStyles();
	const {sign, onChange} = props;
	const [signId, setSignId] = React.useState(0);
	//const [loaded, setLoaded] = React.useState(false);
	//const [types, setTypes] = React.useState([]);
	//const [changed, setChanged] = React.useState(false);
	//const [saveLabel, setSaveLabel] = React.useState('Save');
	const comvars = ['flowControl', 'baud_rate'];
	const [enabled, setEnabled] = React.useState(false);
	const [warned, setWarned] = React.useState(false);
	const [warnOpen, setWarnOpen] = React.useState(false);
	const [com, setCom] = React.useState({
		flowControl: 1,
		baud_rate: 115200,
	});
	const limits = {
		baud_rate: 4294967295,
	};
	React.useEffect(() => {
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			var bds = {};
			comvars.forEach((bd) => bds[bd] = sign[bd]);
			//if(!bds.max_spl_speed)
			//	bds.max_spl_speed = 0;
			setCom(bds);
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//handle enable/disable
	const handleEnable = (e) => {
		if(!warned && e.target.checked)
			setWarnOpen(true);
		setEnabled(e.target.checked);
	}
	

  	const handleAccept = () => {
		setEnabled(true);
		setWarned(true);
    	setWarnOpen(false);
  	};
	
	const handleCancel = () => {
		setEnabled(false);
		setWarnOpen(false);
	}
	
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		let newDetails = Object.assign({}, com);
		
		
		if(name === 'baud_rate'){
			value = parseInt(value);
			//clean the value
			if(isNaN(value) || value < 0){
				value = 0;
			} else if(value > limits[name]){
				value = limits[name];
			}
		} else {
			value = e.target.checked ? 1 : 0;
		}
		newDetails[name] = value;
		if(name === 'flowControl'){
			if(value){
				newDetails.baud_rate = 115200;
			} else {
				newDetails.baud_rate = 19200;
			}
		}
		setCom(newDetails);
		if(onChange){
			onChange(newDetails);
		}
		//setChanged(true);
	}
	const renderForm = () => {
		if(enabled)
			return (
				<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<FormControlLabel
          					control={<Switch checked={Boolean(com.flowControl)} onChange={handleChangeValue} name="flowControl" />}
          					label={com.flowControl ? "Flow control on": "Flow control off"}
        				/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="sign_baud_rate"
							name="baud_rate"
							label="Baud rate"
							type="number"
							value={com.baud_rate.toString()}
							onChange={handleChangeValue}
							inputProps={{min:'0', max:limits.baud_rate, style:{textAlign:'right'}}}
							fullWidth
						/>
					</Grid>
				</Grid>
	  		</CardContent>
			);
		return '';
	}
	
	
	return (
		<Card className={classes.root}>
			<CardHeader title="Communication Settings" action={<FormControlLabel control={<Switch checked={enabled} onChange={handleEnable} name="enabled" />} label={enabled ? 'Show' : 'Hide'} />} />
			{renderForm()}
			<Dialog
        		open={warnOpen}
        		onClose={handleCancel}
        		aria-labelledby="alert-dialog-title"
        		aria-describedby="alert-dialog-description"
      		>
        		<DialogTitle id="alert-dialog-title">{"Configure Advanced Settings"}</DialogTitle>
        		<DialogContent>
          			<DialogContentText id="alert-dialog-description">
            			These are advanced settings. Changing them may result in communication failure. Please consult with a service representative before making changes.
          			</DialogContentText>
        		</DialogContent>
        		<DialogActions>
          			<Button onClick={handleCancel} color="primary">
            			Cancel
          			</Button>
          			<Button onClick={handleAccept} color="secondary" variant="contained" autoFocus>
            			I know what I'm doing
          			</Button>
        		</DialogActions>
      		</Dialog>
	  	</Card>
	);
}
